import { Observable } from 'rxjs';

import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ListNotifications } from '../action-creators';
import { LOGIN_USER_SUCCESS } from '../../auth/actions';
import { LoginUserSuccess } from '../../auth/action-creators';
import AppState from '@webapp/store/state';

export const listUserNotificationsEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, LoginUserSuccess>(LOGIN_USER_SUCCESS),
    withLatestFrom(state$),
    filter(
      ([_, state]) => !state.router.location.pathname.includes('/notifications')
    ),
    map(() => new ListNotifications())
  );
